var countryInfo = {
	countryCode:'TR',
	
	setCountryCode: function(code){
		var code = code.toUpperCase();
		if(code=='INTBUT'){ //international site icin flag.country bu sekilde geliyor.
			code='TR';
		}
		this.countryCode = code;
	}
};

$(document).ready(function() {
	$('#busRegisterForm').validate();
	if(siteId == 1){
		$("#gsm").mask("(999) 999-9999");
	}else{
		$("#gsm").mask("999999999999999");
	}
	
	$("#gsm_code").intlTelInput({
		preferredCountries: [countryInfo.countryCode],
		americaMode: false
	});

	$("#gsm_code").focusout(function(){
		var isTR = $("#gsm_code").val().includes("+90");
		if(isTR){
			$("[name=gsm]").mask("(999) 999-9999");
		}else{
			$("[name=gsm]").mask("999999999999999");
		}
	});

});

function sendInfo(){
	var email = $("#email").val();
	var gsm = $("#gsm").val();
	var contactName = $("#contactName").val();
	var isEmailValid = emailValidation('email');
	if(grecaptcha.getResponse().length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}
	if (!isEmailValid) {
		grecaptcha.reset();
		return false;
	}	
	if (email == "") {
		alert(FmtMessage.getMessage('js.invite.emptyEmail.warn'));
	}else{
		
		var url = "/bus/add";
		$('#busRegisterForm').attr('action', url).submit();
	}
	grecaptcha.reset();
}